export const recentPurchases = [
  { name: 'Sofía G.', city: 'Córdoba', province: 'Córdoba', time: '2 minutes ago' },
  { name: 'Martín R.', city: 'Rosario', province: 'Santa Fe', time: '5 minutes ago' },
  { name: 'Camila L.', city: 'Mendoza', province: 'Mendoza', time: '8 minutes ago' },
  { name: 'Joaquín P.', city: 'La Plata', province: 'Buenos Aires', time: '11 minutes ago' },
  { name: 'Florencia D.', city: 'San Miguel de Tucumán', province: 'Tucumán', time: '14 minutes ago' },
  { name: 'Nicolás B.', city: 'Mar del Plata', province: 'Buenos Aires', time: '18 minutes ago' },
  { name: 'Agustina M.', city: 'Salta', province: 'Salta', time: '23 minutes ago' },
  { name: 'Tomás V.', city: 'Neuquén', province: 'Neuquén', time: '27 minutes ago' },
  { name: 'Julieta F.', city: 'Bariloche', province: 'Río Negro', time: '31 minutes ago' },
]
